/**
 * Mapeamento de IDs de tela (menu.json) para seções da documentação.
 * Quando o usuário clica em "Ver Documentação" no menu do usuário,
 * a tela ativa é usada para navegar diretamente à seção relevante.
 */
export const TELA_PARA_SECAO: Record<string, string> = {
  // Empresa
  'gestao.cadastro.core.empresa': 'empresa',

  // Parceiro
  'gestao.cadastro.core.parceiro': 'parceiro',

  // Produto
  'gestao.cadastro.core.produto': 'produto',

  // Preços
  'gestao.cadastro.core.preco': 'preco',
  'gestao.operacional.preco.gestao': 'preco',
  'gestao.cadastro.lista.produtos': 'preco',

  // Menu e módulos
  'easy.schedule.menu.principal': 'menu',

  // Inteligência
  'gestao.inteligencia.performance.vendas': 'inteligencia',
  'gestao.inteligencia.lucratividade.vendas': 'inteligencia',
  'gestao.inteligencia.monitor.pdv': 'inteligencia',
  'gestao.inteligencia.saude.financeira': 'inteligencia',
  'gestao.inteligencia.provisao.financeira': 'inteligencia',
  'gestao.inteligencia.agenda.dashboard': 'inteligencia',
  'gestao.inteligencia.painel.fiscal': 'inteligencia',
  'gestao.inteligencia.estoque': 'inteligencia',
  'gestao.inteligencia.cliente360': 'inteligencia',
  'gestao.relatorio.lucratividade.produtos': 'inteligencia',
  'gestao.relatorio.resumo.pdv': 'inteligencia',
  'gestao.relatorio.caixa.diario': 'inteligencia',

  // Agenda
  'gestao.cadastro.agenda.configuracao': 'agenda',
  'gestao.cadastro.agenda.unidade.atendimento': 'agenda',
  'gestao.movimento.agenda.agendas': 'agenda',
  'gestao.cadastro.agenda.servico': 'agenda',
  'gestao.cadastro.agenda.executante.resumido': 'agenda',
  'gestao.cadastro.agenda.dayoff': 'agenda',
  'gestao.cadastro.executante': 'agenda',

  // Delivery
  'gestao.delivery.configuracao': 'delivery',
  'gestao.delivery.monitor': 'delivery',
  'gestao.delivery.easy': 'delivery',

  // PDV – configuração
  'gestao.cadastro.configuracao.pdv.easy': 'pdv-config',
  'gestao.cadastro.configuracao.pdv': 'pdv-config',

  // PDV – operação
  'gestao.movimento.pdv.easy': 'pdv-venda',
  'gestao.movimento.gerente.pdv': 'pdv-venda',

  // Compra e Venda (Nota Easy)
  'gestao.movimento.venda.easy': 'nota',
  'gestao.movimento.compra.easy': 'nota',
  'gestao.movimento.nota.easy': 'nota',
  'gestao.movimento.nota.venda': 'nota',
  'gestao.movimento.nota.compra': 'nota',
  'gestao.cadastro.operacao.nota': 'nota',

  // Financeiro
  'gestao.movimento.financeiro.easy': 'financeiro',
  'gestao.movimento.financeiro': 'financeiro',
  'gestao.cadastro.financeiro.recorrente': 'financeiro',
  'gestao.cadastro.regua.cobranca': 'financeiro',
  'gestao.cadastro.tipo.titulo': 'financeiro',
  'gestao.cadastro.tipo.negociacao': 'financeiro',
  'gestao.cadastro.centro.custo': 'financeiro',
  'gestao.cadastro.banco': 'financeiro',
  'gestao.cadastro.conta.bancaria': 'financeiro',

  // Estoque
  'gestao.movimento.estoque': 'estoque',
  'gestao.movimento.inventario': 'estoque',
  'gestao.movimento.rastreio.estoque': 'estoque',
  'gestao.cadastro.categoria.produto': 'estoque',
  'gestao.cadastro.marca': 'estoque',

  // Fiscal
  'gestao.fiscal.configuracao': 'fiscal',
  'gestao.fiscal.certificado.digital': 'fiscal',
  'gestao.fiscal.painel': 'fiscal',
  'gestao.fiscal.exportacao.xml': 'fiscal',
  'gestao.fiscal.importacao.xml': 'fiscal',
  'gestao.fiscal.ibpt': 'fiscal',
  'gestao.fiscal.sintegra': 'fiscal',
  'gestao.fiscal.cte': 'fiscal',
  'gestao.fiscal.cte.operacao': 'fiscal',
  'gestao.fiscal.cte.veiculo': 'fiscal',

  // Academia
  'gestao.academia.turma': 'academia',
  'gestao.academia.aluno': 'academia',
  'gestao.academia.professor': 'academia',
  'gestao.academia.aula.turma': 'academia',
  'gestao.academia.frequencia': 'academia',
  'gestao.academia.comissao.professor': 'academia',
};

export type SecaoDoc =
  | 'empresa'
  | 'parceiro'
  | 'produto'
  | 'preco'
  | 'menu'
  | 'inteligencia'
  | 'agenda'
  | 'delivery'
  | 'pdv-config'
  | 'pdv-venda'
  | 'nota'
  | 'financeiro'
  | 'estoque'
  | 'fiscal'
  | 'academia';

export function getSecaoPorTela(telaId: string | undefined): SecaoDoc | null {
  if (!telaId) return null;
  return (TELA_PARA_SECAO[telaId] as SecaoDoc) ?? null;
}
